const useColumnWidthHelper = (columnWidths, visibleColumns, totalWidth) => {
    const totalColumnWidth = columnWidths
        ? Object.keys(columnWidths).reduce((previousValue, key) => {
            return previousValue + columnWidths[key];
        }, 0)
        : totalWidth;
    const totalStickyColumnSize = visibleColumns.reduce((previousValue, column) => {
        return column.sticky && column.id !== undefined ? previousValue + columnWidths[column.id] : previousValue;
    }, 0);
    return {
        totalColumnWidth,
        totalStickyColumnSize,
    };
};

export { useColumnWidthHelper };
//# sourceMappingURL=useColumnWidthHelper.js.map
